/**
 * Definición canónica de los tabs de la consola de plataforma (ADR-038).
 *
 * Fuente única de verdad consumida por:
 *   - PlatformConsole (tab-bar del layout)
 *   - AppShell variant='platform' (nav del header)
 *
 * Mantenerlos aquí evita desincronizar el nav del shell con el tab-bar
 * cuando se añadan o renombren tabs en el futuro.
 */

export interface PlatformTab {
  /** Identificador único, coincide con el path segment: /platform/{key} */
  key: string;
  /** Etiqueta visible en la UI */
  label: string;
  /** Ruta completa */
  to: string;
}

export const PLATFORM_TABS: PlatformTab[] = [
  { key: 'tenants', label: 'Tenants', to: '/platform/tenants' },
  { key: 'users', label: 'Usuarios', to: '/platform/users' },
  { key: 'billing', label: 'Billing', to: '/platform/billing' },
  { key: 'apis', label: 'APIs', to: '/platform/apis' },
];
